module.exports = __webpack_public_path__ + "static/media/gsuite.ca5ee9a8.png";